import { render, staticRenderFns } from "./DataItem.vue?vue&type=template&id=9a6b3996&scoped=true"
import script from "./DataItem.vue?vue&type=script&lang=js"
export * from "./DataItem.vue?vue&type=script&lang=js"
import style0 from "./DataItem.vue?vue&type=style&index=0&id=9a6b3996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6b3996",
  null
  
)

export default component.exports